export default __webpack_public_path__ + "static/media/checkorange.1ad5d4d3.png";